import { Box, CircularProgress, Container, Grid } from "@mui/material"
import { themePalette } from "../../config/theme.config"
import { I18nContext } from "../../I18nProvider";
import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import IresearhService from "../../services/IresearchService";
import { ProyectoActual } from "../../Interface/IProyecto";
import { NotFoundPage } from "../Error/ErrorNotFound";

export const Proyecto: React.FC<{}> = () => {
    const context = useContext(I18nContext);
    const { id } = useParams<{ id: string }>();
    const [proyectoActual, setProyectoActual] = useState<ProyectoActual>();
    const [loadingProy, setLoadingProy] = useState<boolean>(true);
    const [notFound, setnotFound] = useState<boolean>(false);


    if (context === null) {
        throw new Error(
            "The I18n context is not initialized. Make sure you have the provider set up correctly."
        );
    }

    useEffect(() => {
        if (id) {
            IresearhService.GetProyectoById(id)
                .then((proyActual) => {
                    if (!proyActual.status.isSuccessfully ) {
                        setnotFound(true);
                        return;
                    }
                    const proyectoAct: ProyectoActual = proyActual.data;
                    setProyectoActual(proyectoAct);
                })
                .catch((error) => {
                    console.error("Error fetching user data from backend:", error);
                    setnotFound(true);
                })
                .finally(() => {
                    setLoadingProy(false); 
                });
        } else {
            console.log("No hay nombre unidad");
        }
    }, [id]);


    if (notFound) {
        return (

            <NotFoundPage />

        );
    }


    return (
        <Container >
            <Grid>
                <h1>Proyecto</h1>
            </Grid>
            <Grid container direction="row" justifyContent="space-between"  sx={{ borderTop: `2px solid ${themePalette.NAVCOLOR}` }} >
                
                
                <Grid item xs={12} sm={6} md={6}>
                    {loadingProy ? (
                        <CircularProgress />
                    ) : (
                    <Box>
                            <h3>{proyectoActual?.titulo}</h3>
                            <p><strong>{context.t.translate("proyecto.fechain")}: </strong>{proyectoActual?.fechainicio}</p>
                            <p><strong>{context.t.translate("proyecto.fechafin")}: </strong>{proyectoActual?.fechafin}</p>
                                <h3>{context.t.translate("proyecto.participante")}</h3>
                                <h3>{context.t.translate("proyecto.insEspol")}</h3>
                                <ul>
                                    {proyectoActual?.instituciones.institucionesEspol.map((institucion, index) => (
                                        <li key={index}>
                                            <strong>{context.t.translate("proyecto.unidad")}:</strong> {institucion.unidad}
                                        </li>
                                    ))}
                                </ul>
                                <h3>{context.t.translate("proyecto.colaboradoresEs")}</h3>
                                <ul>
                                    {proyectoActual?.colaboradores.colaboradoresEspol.map((colaborador, index) => (
                                        <li key={index}>
                                            <strong>{context.t.translate("proyecto.rol")}:</strong> {colaborador.rol} <br />
                                            <strong>{context.t.translate("proyecto.nombre")}:</strong> {colaborador.nombre}
                                        </li>
                                    ))}
                                </ul>
                            
                                {(proyectoActual?.instituciones?.institucionesExterna || []).length > 0 && (
                                    <Box>
                                        <h3>{context.t.translate("proyecto.exInsEspol")}</h3>
                                        <ul>
                                            {proyectoActual?.instituciones.institucionesExterna.map((institucion, index) => (
                                                <li key={index}>
                                                    <strong>{context.t.translate("proyecto.tipoI")}:</strong> {institucion.tipoEntidad} <br />
                                                    <strong>Institución:</strong> {institucion.nombre} 
                                                </li>
                                            ))}
                                        </ul>
                                    </Box>
                                )}
                                {(proyectoActual?.colaboradores?.colaboradoresExterno || []).length > 0 && (
                                    <Box>
                                        <h3>{context.t.translate("proyecto.colaboradoresEx")}</h3>
                                        <ul>
                                            {proyectoActual?.colaboradores.colaboradoresExterno.map((colaborador, index) => (
                                                <li key={index}>
                                                    <strong>{context.t.translate("proyecto.rol")}:</strong> {colaborador.rol} <br />
                                                    <strong>{context.t.translate("proyecto.nombre")}:</strong> {colaborador.nombre}
                                                </li>
                                            ))}
                                        </ul>
                                    </Box>
                                )}
                    </Box>
                    )}
                </Grid>
                    <Grid item xs={12} sm={4} md={4} >
                    {loadingProy ? (
                        <CircularProgress />
                    ) : (
                        <Box>
                            <h3>{context.t.translate("investigador.areas")}</h3>
                            
                                <ul>
                                    {proyectoActual?.areasCon.objSegunFrascati.map((area, index) => (
                                        <li key={index}>
                                            <strong>{context.t.translate("proyecto.area")}:</strong> {area.areaConocimiento} <br />
                                            <strong>{context.t.translate("proyecto.subarea")}:</strong> {area.subAreaConocimiento}
                                        </li>
                                    ))}
                                </ul>
                        </Box>
                    )}
                    </Grid>
            </Grid>

        </Container>
    )
}